import React from 'react';

import OrganizationHeader from '../containers/header/OrganizationHeader';
import OrganizationCover from '../containers/cover/OrganizationCover';
import OrganizationReport from '../containers/organizationReport/OrganizationReport';

import isAuthorizedCurrentOrganization from '../hoc/CurrentOrganizationAuthorization';

const OrganizationReportPage = props => {
    return (
        <React.Fragment>
            <OrganizationHeader />
            <OrganizationCover />
            <OrganizationReport {...props} />
        </React.Fragment>
    );
};

export default isAuthorizedCurrentOrganization(OrganizationReportPage, true);



// WEBPACK FOOTER //
// ./src/pages/OrganizationReportPage.js